import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import HelpToolTip from 'components/HelpToolTip';
import { StyledTypographyColorSectionNavLinkMainMedium } from 'components/StyledTypographyColorSectionNavLinkMainMedium';
import TaxesAndFeesHelpText from 'catering/components/Cart/TaxesAndFeesHelpText';
import { mapCartToServiceFeeType } from 'catering/helpers/HonestPricingLaw';

const flexProps = {
  justifyContent: 'space-between',
  display: 'flex'
};

const CartInfoTaxesAndFees = ({
  shouldShowTransparentFees,
  taxFieldLabel,
  taxesAndFees,
  tax,
  serviceFee,
  customFee,
  customFeeName,
  bundleServiceFeeWithCustomFee,
  bundledServiceAndCustomFees,
  displayServiceFee,
  ...cartInfoStyles
}) => {
  if (shouldShowTransparentFees) {
    const { feeType, cartItemizedHelperText } = mapCartToServiceFeeType(
      displayServiceFee
    );

    return (
      <>
        {/* Catering Order Service Fee */
        !!parseFloat(serviceFee) && (
          <Box marginBottom={1} {...flexProps}>
            <Box display="flex" alignItems="center">
              <StyledTypographyColorSectionNavLinkMainMedium
                {...cartInfoStyles}
              >
                {feeType}
              </StyledTypographyColorSectionNavLinkMainMedium>
              <HelpToolTip>{cartItemizedHelperText}</HelpToolTip>
            </Box>
            <StyledTypographyColorSectionNavLinkMainMedium {...cartInfoStyles}>
              ${serviceFee}
            </StyledTypographyColorSectionNavLinkMainMedium>
          </Box>
        )}

        {!!customFeeName && (
          <Box marginBottom={1} {...flexProps}>
            <Box display="flex" alignItems="center">
              <StyledTypographyColorSectionNavLinkMainMedium
                {...cartInfoStyles}
              >
                {'Other Fees'}
              </StyledTypographyColorSectionNavLinkMainMedium>
              <HelpToolTip>{`${customFeeName}: ${customFee}`}</HelpToolTip>
            </Box>
            <StyledTypographyColorSectionNavLinkMainMedium {...cartInfoStyles}>
              ${customFee}
            </StyledTypographyColorSectionNavLinkMainMedium>
          </Box>
        )}

        {/* Sales Tax */}
        <Box marginBottom={1} {...flexProps}>
          <Box display="flex" alignItems="center">
            <StyledTypographyColorSectionNavLinkMainMedium {...cartInfoStyles}>
              Sales Tax
            </StyledTypographyColorSectionNavLinkMainMedium>
          </Box>
          <StyledTypographyColorSectionNavLinkMainMedium {...cartInfoStyles}>
            ${tax}
          </StyledTypographyColorSectionNavLinkMainMedium>
        </Box>
      </>
    );
  }

  return (
    <Box marginBottom={1} {...flexProps}>
      <Box display="flex" alignItems="center">
        <StyledTypographyColorSectionNavLinkMainMedium {...cartInfoStyles}>
          {taxFieldLabel}
        </StyledTypographyColorSectionNavLinkMainMedium>
        {taxesAndFees && (
          <HelpToolTip data-testid="taxes-tooltip">
            <TaxesAndFeesHelpText
              tax={tax}
              serviceFee={serviceFee}
              customFee={customFee}
              customFeeName={customFeeName}
              bundleServiceFeeWithCustomFee={bundleServiceFeeWithCustomFee}
              bundledServiceAndCustomFees={bundledServiceAndCustomFees}
            />
          </HelpToolTip>
        )}
      </Box>
      <StyledTypographyColorSectionNavLinkMainMedium
        data-testid="cart-tax"
        {...cartInfoStyles}
      >
        ${taxesAndFees || tax}
      </StyledTypographyColorSectionNavLinkMainMedium>
    </Box>
  );
};

CartInfoTaxesAndFees.propTypes = {
  bundleServiceFeeWithCustomFee: PropTypes.bool,
  bundledServiceAndCustomFees: PropTypes.string,
  customFee: PropTypes.string,
  customFeeName: PropTypes.string,
  serviceFee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  taxesAndFees: PropTypes.string,
  taxFieldLabel: PropTypes.string,
  shouldShowTransparentFees: PropTypes.bool.isRequired,
  displayServiceFee: PropTypes.string.isRequired
};

export default CartInfoTaxesAndFees;
